"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateV4UUID = void 0;
const uuid_1 = require("uuid");
function generateV4UUID() {
    const uuid = (0, uuid_1.v4)();
    return uuid;
}
exports.generateV4UUID = generateV4UUID;
//# sourceMappingURL=generate-v4-uuid.js.map